import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField, } from '../../../../../components';
import { Button, Container, Dialog, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box, Radio } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN } from '../../../../../constants/dropdown';
import { formatDate } from '../../../../../utils';

const initialPatientDataObj = {
    data: [],
    loading: false
};
const initialPosDataObj = {
    data: [],
    loading: false
};


export const RadServiceAckUpdateStatus = () => {
    const doctorIDRef = useRef();
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
    const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [opdData, setOpdData] = useState([])
    const [selectedRadio, setSelectedRadio] = useState('acknowledged');
    const [opdFilterData, setOpdFilterData] = useState({ data: [] });
    const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
    const [doctorDropdown, setDoctorDropdown] = useState([])
    const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
    const [patientService, setPatientService] = useState(null)
    const [serviceDropdown, setServiceDropdown] = useState([])





    const { getValues } = useForm()
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({

            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const IPD_TABLE_HEADER = [
        { header: 'Ack.Doc.No.', accessor: "doc_no" },
        { header: 'Bill Date', accessor: (row) => formatDate(row?.date) },
        { header: 'Patient Name', accessor: (row) => `${row?.patient?.name_suffix}${row?.patient?.first_name}` },
        { header: 'Uhid No.', accessor: 'uhid' },
        {
            header: 'Service Name',
            accessor: (row) => row?.services?.service_name
        },
        { header: 'Room No.', accessor: '' },
    ];




    const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        if (!selectedRecord && !getValues('consultant')) {
            const [defaultState] = data.filter(({ status }) => status === 'default');
            setValue('consultant', defaultState?._id);
            if (defaultState) {
                setValue('department', defaultState.qualification_details.department);
            }
        }
        setDoctorDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getServiceDropdown = useCallback(async () => {
        const data = await dropdownFetch('service');
        setServiceDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getRoomMasterDropdown = useCallback(async () => {
        const data = await dropdownFetch('radiology-room-master');
        setRoomMasterDropdown(data);
    }, [selectedRecord, getValues, setValue]);


    useEffect(() => {
        getDoctorDropdown()
        getServiceDropdown()
        getRoomMasterDropdown()
    }, [getDoctorDropdown, getServiceDropdown, getRoomMasterDropdown])


    const handleRadioChange = (event) => {
        const { name } = event.target;
        setSelectedRadio(name);
    };


    const formSubmit = async (formValues) => {
        setLoading(true);
        const services = patientService
        const serviceBilling = selectedRadio

        const payload = {
            ...formValues,
            services,
            serviceBilling
        };
        try {
            const response = await request('/service-acknowledgement-create', {
                method: 'POST',
                body: payload,
            });

            if (response?.success && response.data) {
                toast(`Successfully ${'created'} Radiology Acknowledgement`, { variant: 'success' });
                setSelectedRecord(response.data);
                fetchIpdPatient()
                setPatientService([])
                reset()
            } else {
                toast(`Failed to ${'create'} Radiology Acknowledgement`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };



    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleRowClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', row?.patient?.name)
        setValue('uhid', row?.patient?.uhid)
        setValue('ipd_no', row?.ipd_no)
        setValue('consultant', row?.
            indoorRegisteration?.consultant_detail?.
            doctor)
        setValue('gender', row?.patient?.gender)
        setValue('age', calculateAge(row?.patient?.dob))
        setValue('bill_no', row?.bill_no)
        setValue('mobile_no', row?.patient?.
            mobile_no)
    };
    const handleRowOpdClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', `${row?.patient?.name}`)
        setValue('gender', `${row?.patient?.gender}`)
        setValue('age', calculateAge(row?.patient.dob))
        setValue('uhid', row?.uhid)
        setValue('consultant', row?.patient?.consultant)
        doctorIDRef.current = row?.consultant?._id;
        setValue('sponsor', row?.sponsor?._id)
        setValue('bill_no', row?.bill_no)
    };

    useEffect(() => {
        fetchIpdPatient()
    }, [selectedRadio])


    const fetchIpdPatient = async () => {
        setIndoorRegisterationDataObj({ loading: true });
        try {
            const response = await request('/service-acknowledgement-list', { method: 'GET' });
            if (response.success) {
                const filterData = response.data.filter((item) => {
                    if (!selectedRadio || item.services.report_type === selectedRadio) {
                        return true;
                    }
                    return false;
                });
                setIndoorRegisterationDataObj({ loading: false, data: filterData });
            } else {
                toast('Error in fetching data', { variant: 'error' });
                setIndoorRegisterationDataObj({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching IPD patient data:', error);
            toast('Error in fetching data', { variant: 'error' });
            setIndoorRegisterationDataObj({ loading: false });
        }
    };

    useEffect(() => {
        console.log("HELLLLO PATINET DETAILS IS HERE", indoorRegisterationDataObj)
    }, [indoorRegisterationDataObj])

    useEffect(() => {
        fetchIpdPatient()
    }, [])

    const handleStatusDefChange = async (row, type) => {
        setLoading(true);
        try {
            const response = await request('/service-acknowledgement-def', {
                method: 'PUT',
                params: row._id,
                body: { service_id: row.services.service }
            });
            if (response?.success && response.data) {
                toast(`Successfully updated Radiology Acknowledgement`, { variant: 'success' });
                setSelectedRecord(response.data);
                reset();
            } else {
                console.error(response.message || 'Failed to update report type');
                toast(`Failed to update Radiology Acknowledgement`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };


    const handleStatusCancelChange = async (row, type) => {
        setLoading(true);
        try {
            const response = await request('/service-acknowledgement-cancel', {
                method: 'PUT',
                params: row._id,
                body: { service_id: row.services.service }
            });
            if (response?.success && response.data) {
                toast(`Successfully updated Radiology Acknowledgement`, { variant: 'success' });
                setSelectedRecord(response.data);
                reset();
            } else {
                console.error(response.message || 'Failed to update report type');
                toast(`Failed to update Radiology Acknowledgement`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleStatusDoneChange = async (row, type) => {
        setLoading(true);
        try {
            const response = await request('/service-acknowledgement-done', {
                method: 'PUT',
                params: row._id,
                body: { service_id: row.services.service }
            });
            if (response?.success && response.data) {
                toast(`Successfully updated Radiology Acknowledgement`, { variant: 'success' });
                setSelectedRecord(response.data);
                fetchIpdPatient()
                reset();
            } else {
                console.error(response.message || 'Failed to update report type');
                toast(`Failed to update Radiology Acknowledgement`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Radiology Service Acknowledgement Update Status
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                >
                                    Apply
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '80%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                {/* Left side container with radio buttons and table */}
                                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    {/* Radio Button and Labels Stack */}
                                    <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                        <Stack spacing={0.2} direction="row" alignItems="center">
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Report Type</Typography>
                                            <Radio
                                                sx={{ flex: 0.3 }}
                                                name="acknowledged"
                                                value="acknowledged"
                                                checked={selectedRadio === 'acknowledged'}
                                                onChange={handleRadioChange}
                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', color: "red" }}>Acknowledged</Typography>
                                            <Radio
                                                sx={{ flex: 0.2 }}
                                                value="deferred"
                                                name="deferred"
                                                checked={selectedRadio === 'deferred'}
                                                onChange={handleRadioChange}
                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', color: "red" }}>Deferred</Typography>
                                            <Radio
                                                sx={{ flex: 0.2 }}
                                                value="cancelled"
                                                name="cancelled"
                                                checked={selectedRadio === 'cancelled'}
                                                onChange={handleRadioChange}
                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', color: "red" }}>Cancelled</Typography>
                                            <Radio
                                                sx={{ flex: 0.2 }}
                                                name="procedure_done"
                                                value="procedure_done"
                                                checked={selectedRadio === 'procedure_done'}
                                                onChange={handleRadioChange}
                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', color: "red" }}>Procedure Done</Typography>
                                        </Stack>
                                    </Grid>
                                    {/* Table section - full width */}
                                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row' }}>
                                        <Table
                                            containerSX={{
                                                width: '100%',
                                                maxHeight: '100%',  // Set a maximum height for the table
                                                overflowY: 'auto',   // Enable vertical scrolling when content exceeds maxHeight
                                               
                                                border: '0px solid rgba(0,0,0,0.27)'
                                            }}
                                            data={indoorRegisterationDataObj.data || []}
                                            columns={IPD_TABLE_HEADER}
                                            size="small"
                                            showStatuses={true}
                                            handleStatusDefChange={handleStatusDefChange}
                                            handleStatusCancelChange={handleStatusCancelChange}
                                            handleStatusDoneChange={handleStatusDoneChange}
                                            onRowClick={handleRowClick}
                                        />
                                    </Grid>


                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container >
            </Paper >

        </>
    );
};
